import { Loader } from "google-maps";
import { MarkerClusterer, GridAlgorithm } from "@googlemaps/markerclusterer";
import { MarkerWithLabel } from "@googlemaps/markerwithlabel";
// @ts-ignore
import serialize from "form-serialize";
import { fetchFromApiOptionway } from "./guidance";

export default async function destinationMap() {
    // Variables globales
    const filter_id = window.drupalSettings.filter_id == "" ? "" : "/" + window.drupalSettings.filter_id;
    const url_ajax = "/" + window.drupalSettings.path.pathPrefix + "ajax/destination/map/rest" + filter_id;
    const lang = document.documentElement.lang;
    const translations = window.translations;
    let pendingRequest = false;

    // Create map
    const loader = new Loader("AIzaSyDROHqIm0so7OaPI43XCY2hEy7c0-ojsMw");
    const google = await loader.load();
    const map = createMap(google);
    let markers: any[] = [];
    let markerCluster: any = null;

    const guidanceMap = document.querySelector(".guidance-map") as HTMLElement;
    const formFilters = document.querySelector(".guidance-filters-form") as HTMLElement;
    const counter = document.querySelector(".counter--destinations em") as HTMLElement;

    function setData() {
        const form = document.querySelector(".guidance-form") as HTMLElement;
        const where = form?.querySelector('[name="where"]') as HTMLInputElement;
        const tos = form?.querySelector('[name="hiddens[tos]"]') as HTMLInputElement;
        const country = form?.querySelector('[name="hiddens[country]"]') as HTMLInputElement;
        const region_airports = form?.querySelector('[name="hiddens[regionAirports]"]') as HTMLInputElement;
        const maxPrice = form?.querySelector('[name="hiddens[maxPrice]"]') as HTMLInputElement;
        const departureDate = form?.querySelector('[name="hiddens[departureDate]"]') as HTMLInputElement;
        const departureDays = form?.querySelector('[name="hiddens[departureDays]"]') as HTMLInputElement;
        const departureMonths = form?.querySelector('[name="hiddens[departureMonths]"]') as HTMLInputElement;
        const durationMax = form?.querySelector('[name="hiddens[durationMax]"]') as HTMLInputElement;
        const durationMin = form?.querySelector('[name="hiddens[durationMin]"]') as HTMLInputElement;
        const filterTimeInput = document.querySelector('[name="filter_time_slider"]') as HTMLInputElement;
        const direct = document.querySelector('[name="direct"]') as HTMLInputElement;
        const criterionEnvironmentCheckboxes = document.querySelectorAll(
            'input[name^="criteria_environment"]'
        ) as NodeListOf<HTMLInputElement>;
        const criterionDesireCheckboxes = document.querySelectorAll(
            'input[name^="criterion_desire"]'
        ) as NodeListOf<HTMLInputElement>;

        let data = {} as any;

        if (where?.value) data.where = where.value;
        if (tos?.value) data.tos = tos.value;
        if (country?.value) data.country = country.value;
        if (region_airports?.value) data.region_airports = region_airports.value;
        if (maxPrice?.value) data.maxPrice = parseInt(maxPrice.value);
        if (departureDate?.value) data.departureDate = departureDate.value;
        if (!departureDate?.value) {
            if (departureDays?.value) data.departureDays = departureDays.value;
            if (departureMonths?.value) data.departureMonths = departureMonths.value;
        }
        if (durationMax?.value) data.durationMax = parseInt(durationMax.value);
        if (durationMin?.value) data.durationMin = parseInt(durationMin.value);
        if (filterTimeInput?.value) data.maxFlightTime = filterTimeInput.value;
        if (direct?.checked) data.direct = true;

        if (criterionEnvironmentCheckboxes) {
            const checkedIds = Array.from(criterionEnvironmentCheckboxes)
                .filter((input) => input.checked)
                .map((input) => parseInt(input.name.match(/\[(\d+)\]/)?.[1] || ""))
                .filter(Boolean);
            if (checkedIds.length > 0) data.environments = checkedIds;
        }

        if (criterionDesireCheckboxes) {
            const checkedIds = Array.from(criterionDesireCheckboxes)
                .filter((input) => input.checked)
                .map((input) => parseInt(input.name.match(/\[(\d+)\]/)?.[1] || ""))
                .filter(Boolean);
            if (checkedIds.length > 0) data.desires = checkedIds;
        }

        return data;
    }

    // Serialize url.
    function serializeQueryParameters(obj: any) {
        let str = [];
        for (let p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

    async function fetchGuidanceResponse(apiOptionwayResponseString: string) {
        if (pendingRequest) {
            return;
        }
        pendingRequest = true;

        try {
            // Nettoyer la carte avant tout nouvel appel
            if (markers.length > 0) {
                removeAllMarkers(markers, markerCluster);
                markerCluster = null;
            }

            const params = setData();
            const serializedParams = serializeQueryParameters(params);
            const btnValidFilters = document.querySelector('[data-twig-suggestion="filtered"]') as HTMLElement;

            let bodyOfPost = JSON.stringify({
                dataApi: apiOptionwayResponseString,
                filters: serializedParams,
                counters: true,
            });

            // Récupérer les points depuis /guidance/map
            const mapResponse = await fetch(`/${lang}/ajax/guidance/map`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: bodyOfPost,
            });

            const destinations = await mapResponse.json();

            // Mettre à jour la carte avec les données
            await initMap(destinations, filter_id, map, google);

            // Ensuite, récupérer le compteur pour le volet filtre depuis /guidance/twig
            const countResponse = await fetch(`/${lang}/ajax/guidance/twig`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: bodyOfPost,
            });

            const count = await countResponse.json();

            // Mise à jour des compteurs avec le nombre de /guidance/twig
            if (btnValidFilters) {
                btnValidFilters.textContent = translations.show_destinations.replace("#counter", count);
            }
            if (counter) {
                counter.textContent = String(count);
            }
        } catch (error) {
            console.error("Erreur lors de la mise à jour de la carte:", error);
        } finally {
            setTimeout(() => {
                pendingRequest = false;
            }, 500); // Ajouter un délai avant de permettre une nouvelle requête
        }
    }

    async function triggerCounterFilter() {
        if (pendingRequest) return;

        const params = setData();
        const api_optionway_response = document.querySelector(".api_optionway_response")?.textContent;

        if (api_optionway_response) {
            try {
                const serializedParams = serializeQueryParameters(params);
                const btnValidFilters = document.querySelector('[data-twig-suggestion="filtered"]') as HTMLElement;

                let bodyOfPost = JSON.stringify({
                    dataApi: api_optionway_response,
                    filters: serializedParams,
                    counters: true,
                });

                // Récupérer le compteur depuis /guidance/twig
                const countResponse = await fetch(`/${lang}/ajax/guidance/twig`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: bodyOfPost,
                });

                const count = await countResponse.json();

                // Mise à jour des compteurs
                if (btnValidFilters) {
                    btnValidFilters.textContent = translations.show_destinations.replace("#counter", count);
                }
                if (counter) {
                    counter.textContent = String(count);
                }
            } catch (error) {
                console.error("Erreur lors de la mise à jour des filtres:", error);
            }
        }
    }

    if (guidanceMap) {
        const store = document.querySelector(".store") as HTMLElement;
        let hasInitialLoad = false;

        const handleApiResponse = async (apiResponse: string) => {
            await fetchGuidanceResponse(apiResponse);
            hasInitialLoad = true;
        };

        // Gestionnaire de mutations simplifié
        const observerMap = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.type === "childList") {
                    const responseElement = store.querySelector(".api_optionway_response");
                    if (responseElement && responseElement.textContent) {
                        handleApiResponse(responseElement.textContent);
                        break;
                    }
                }
            }
        });

        observerMap.observe(store, {
            childList: true,
            subtree: true,
        });

        // Gestion du formulaire de recherche
        const searchForm = document.querySelector(".guidance-form") as HTMLFormElement;
        searchForm?.addEventListener("submit", async (e) => {
            e.preventDefault();
            pendingRequest = false;

            const params = setData();
            try {
                const oldResponse = store.querySelector(".api_optionway_response");
                if (oldResponse) {
                    oldResponse.remove();
                }
                await fetchFromApiOptionway(params, store);
            } catch (error) {
                console.error("Erreur lors de la recherche:", error);
            }
        });

        // Gestionnaire des filtres
        const btnValidFilters = document.querySelector('[data-twig-suggestion="filtered"]') as HTMLElement;
        btnValidFilters?.addEventListener("click", async () => {
            const params = setData();
            pendingRequest = false;
            try {
                await fetchFromApiOptionway(params, store);
            } catch (error) {
                console.error("Erreur lors de la mise à jour des filtres:", error);
            }
        });

        // Filter change handlers
        if (formFilters) {
            const filtersCheckboxes = formFilters.querySelectorAll(".form-checkbox");
            const filterTimeInput = formFilters.querySelector('[name="filter_time_slider"]') as HTMLInputElement;

            filtersCheckboxes?.forEach((input) => {
                input.addEventListener("change", triggerCounterFilter);
            });

            if (filterTimeInput) {
                filterTimeInput.addEventListener("change", triggerCounterFilter);
            }
        }
    } else {
        try {
            const response = await fetch(url_ajax);
            if (response.ok) {
                const destinations = await response.json();
                await initMap(destinations, filter_id, map, google);
            } else {
                console.log("HTTP-Error: " + response.status);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    function removeAllMarkers(markers: any, markerCluster: any) {
        if (markerCluster) {
            markerCluster.clearMarkers();
        }

        for (let i = 0; i < markers.length; i++) {
            if (markers[i]) {
                markers[i].setMap(null);
                markers[i] = null;
            }
        }
        markers.length = 0; // Vide complètement le tableau
    }

    async function initMap(destinations: any, filter_id: any, map: any, google: any) {
        if (destinations.length !== undefined) {
            // S'assurer que tous les anciens marqueurs sont supprimés
            removeAllMarkers(markers, markerCluster);
            markerCluster = null;
            let bounds = new google.maps.LatLngBounds();
            let infoWindow = new google.maps.InfoWindow({
                pixelOffset: new google.maps.Size(-20, -45),
            });

            destinations.forEach((destination: any) => {
                createMarker(map, markers, destination, bounds, infoWindow);
            });

            createMarkerClusterer(map, markers);

            if (filter_id) {
                if (destinations.length == 1) {
                    map.setZoom(8);
                    const coordinates = destinations[0].field_coordinates;
                    map.setCenter(new google.maps.LatLng(coordinates.lat, coordinates.lng));
                } else {
                    map.setZoom(6);
                    //map.fitBounds(bounds);
                }
            }

            map.addListener("click", function () {
                closeMarkers(markers, infoWindow);
            });

            map.addListener("zoom_changed", function () {
                closeMarkers(markers, infoWindow);
            });
        }
    }

    function createMap(google: any) {
        const mapStyles = [
            {
                featureType: "administrative",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#828282",
                    },
                ],
            },
            {
                featureType: "administrative",
                elementType: "geometry.fill",
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "landscape",
                elementType: "all",
                stylers: [
                    {
                        color: "#F4F4F2",
                    },
                ],
            },
            {
                featureType: "landscape.man_made",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#828282",
                    },
                    {
                        lightness: "36",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "all",
                stylers: [
                    {
                        visibility: "simplified",
                    },
                ],
            },
            {
                featureType: "road",
                elementType: "all",
                stylers: [
                    {
                        saturation: -100,
                    },
                    {
                        lightness: 45,
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "all",
                stylers: [
                    {
                        visibility: "simplified",
                    },
                ],
            },
            {
                featureType: "road.arterial",
                elementType: "labels.icon",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "transit",
                elementType: "all",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "all",
                stylers: [
                    {
                        color: "#CAD2D3",
                    },
                    {
                        visibility: "on",
                    },
                ],
            },
            { featureType: "poi", stylers: [{ visibility: "off" }] },
            { featureType: "transit", stylers: [{ visibility: "off" }] },
        ];

        const center: google.maps.LatLngLiteral = { lat: 47.16910520252873, lng: -1.6141251552252385 };
        const mapOptions = {
            center,
            zoom: 4,
            minZoom: 4,
            styles: mapStyles,
            streetViewControl: false,
        };

        return new google.maps.Map(document.getElementById("destination-map") as HTMLElement, mapOptions);
    }

    function createMarker(map: any, markers: any, destination: any, bounds: any, infoWindow: any) {
        const title = String(destination.title);
        const position = destination.field_coordinates;

        // Check for page map vs page map in guidance.
        let newLatLng;
        if (typeof position === "string") {
            const lat = parseFloat(position.split(',')[1]);
            const lng = parseFloat(position.split(',')[0]);
            newLatLng = new google.maps.LatLng(lat, lng);
        } else {
            newLatLng = position
        }

        const marker = new MarkerWithLabel({
            map: map,
            position: newLatLng,
            clickable: true,
            title: title,
            icon: " ",
            labelContent: `<p><strong>${title}</strong></p><p>A partir de <strong>${destination.field_cheapflight_price}€</strong></p>`,
            labelAnchor: new google.maps.Point(-90, -40),
            labelClass: "destination-label",
        });

        bounds.extend(newLatLng);

        addInfoWindow(map, marker, destination, infoWindow);
        markers.push(marker);
    }

    function addInfoWindow(map: any, marker: any, destination: any, infoWindow: any) {
        marker.addListener("click", function (this: any) {
            const thumbnail = destination.field_thumbnail;
            const title = destination.title;
            const country_label = destination.field_country_label;
            const country_url = destination.field_country_url;
            const destination_type = destination.field_destination_type;
            const field_destination_type_key = destination.field_destination_type_key;
            const destination_url = destination.destination_url;
            const cheapflight_url = destination.field_cheapflight_url;
            let destination_type_class = destination_type;
            destination_type_class = destination_type_class.replaceAll(" ", "-");
            destination_type_class = destination_type_class.toLowerCase();
            const price = destination.field_cheapflight_price
                ? '<div class="card__price">' + destination.field_cheapflight_price + "€</div>"
                : "";
            const departure_date = destination.field_cheapflight_departure_date;
            const return_date = destination.field_cheapflight_return_date;
            let destination_title = "";
            let destination_thumbnail = "";

            if (field_destination_type_key == "direct") {
                destination_title = `<a href="${destination_url}">${title}</a>`;
                destination_thumbnail = `<a href="${destination_url}">${thumbnail}</a>`;
            } else {
                destination_title = title;
                destination_thumbnail = thumbnail;
            }

            let html =
                `<div class="card destination-infowindow">` +
                `<p class="card__picture card__picture--default">${destination_thumbnail}</p>` +
                `<div class="card__content">` +
                `<div class="card__title"><h3>${destination_title}, <a href="${country_url}">${country_label}</a></h3></div>` +
                `<div class="card__flight-type ${destination_type_class}">${destination_type}</div>` +
                `${price}` +
                `<div class="card__date">Du ${departure_date} au ${return_date}</div>` +
                `<a href="${cheapflight_url}" target="_blank" class="btn">${translations.validate}</a>` +
                `</div>`;
            `</div>`;

            const labels = document.querySelectorAll(".destination-label");
            labels.forEach((label: Element) => {
                label.classList.remove("open");
            });

            this.set("labelClass", "destination-label open");
            infoWindow.setContent(html);
            infoWindow.setPosition(this.getPosition());

            infoWindow.open(map, marker);
        });
    }

    function createMarkerClusterer(map: any, markers: any) {
        const svg = window.btoa(`
                    <svg width="70" height="60" viewBox="0 0 70 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="69" height="59" rx="23.5" fill="white"/>
                    <rect x="0.5" y="0.5" width="69" height="59" rx="23.5" stroke="#B2C6CE"/>
                    </svg>`);

        const renderer = {
            render: ({ count, position }: any) =>
                new google.maps.Marker({
                    label: { text: String(count), color: "##10213A", fontSize: "14px", fontWeight: "400" },
                    icon: {
                        url: `data:image/svg+xml;base64,${svg}`,
                    },
                    position,
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                }),
        };

        const algorithm = new GridAlgorithm({
            gridSize: 60,
        });

        markerCluster = new MarkerClusterer({ map, markers, algorithm, renderer });
    }

    function closeMarkers(markers: any, infoWindow: any) {
        if (infoWindow) infoWindow.close();

        markers.forEach((marker: any) => {
            marker.set("labelClass", "destination-label");
        });
    }
}
